import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription, Observable } from 'rxjs/Rx';
import { timer } from 'rxjs/observable/timer';
import { EventManager, JhiLanguageService, AlertService } from 'ng-jhipster';
import { CRUD_ACTIONS, DateUtilities, Principal } from '../../shared';

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs/Subject';
import { of as observableOf, of } from 'rxjs/observable/of';
import { catchError, finalize, map, switchMap, takeUntil, takeWhile, tap } from 'rxjs/operators';

import { LessonService, LessonUtilService} from '../lesson';
import { StudentTypeaheadService, Student} from '../student/';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { LessonFamily, LessonFamilyService, LessonFamilyWithContextDetails } from '../lesson-family';
import { StudentCardSelection } from './student-card-selection.model';
import { Card, CardService } from '../card';
import { CardType } from '../card-type';
import { ClassType, ClassTypeService, ClassTypeUtilService } from '../class-type';
import { LocationService, Location } from '../location';
import { ReservationFamilyService } from './reservation-family.service';
import { ReservationFamilyBulkCreateBackgroundJobResult, ReservationFamilyBulkCreateInput } from './reservation-family.model';
import { forkJoin } from 'rxjs/observable/forkJoin';

@Component({
    selector: 'jhi-reservation-family-create',
    templateUrl: './reservation-family-create.component.html'
})
export class ReservationFamilyCreateComponent implements OnInit, OnDestroy {

    // variables for the recurrent reservations tab
    recurrentReservationsPage: any;
    recurrentReservationsPreviousPage: any;
    isLoadingRecurrintReservations: boolean;

    // typeahead for the student
    studentSearch = this.studentTypeaheadService.search;
    studentResultFormatter = this.studentTypeaheadService.resultFormatter;
    studentInputFormatter = (student: any) => this.studentTypeaheadService.inputFormatter(student, () => this.selectedStudent['user']);
    selectedStudent: Student;

    // variables for lesson Family selection step
    lessonFamilies: LessonFamilyWithContextDetails [];
    currentSearchByDateFrom: NgbDateStruct;
    currentSearchByDateTo: NgbDateStruct;
    minDateUntil: NgbDateStruct;
    maxDateUntil: NgbDateStruct;
    currentSearchByLocation: string;
    currentSearchByClassType: string;
    classTypes: ClassType [];
    locations: Location [];
    isLoadingLessonFamilies: boolean;

    // variables for the student selection step
    compatibleCardTypes: CardType [];
    studentCardsSelections: StudentCardSelection [];
    recurrentReservationCurrentStep: number;
    minDate: NgbDateStruct;
    maxDate: NgbDateStruct;

    // variables for the creation of the recurrent reservations
    recurrentReservationsCreated: any;
    private currentAttemptKey: string | null = null;

    // variables for polling
    pollIntervalMs: number = 5000;
    private pollSubscription: Subscription;
    private readonly destroy$ = new Subject<void>();
    lastError: string;
    reservationFamilyBulkCreateResult: ReservationFamilyBulkCreateBackgroundJobResult;

    // variables to card creation
    cardSubscriber: Subscription;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private studentTypeaheadService: StudentTypeaheadService,
        private lessonFamilyService: LessonFamilyService,
        private lessonService: LessonService,
        private cardService: CardService,
        private classTypeService: ClassTypeService,
        private locationService: LocationService,
        private reservationFamilyService: ReservationFamilyService,
        private alertService: AlertService,
        private principal: Principal,
        private eventManager: EventManager,
        private classTypeUtilService: ClassTypeUtilService
    ) {
        this.jhiLanguageService.setLocations(['lesson', 'lessonFamily', 'reservation-family', 'card', 'cardType']);
    }

    ngOnInit() {
        this.goToStep(1);
        this.registerChangeInCards();
    }

    addSelectedStudent(): void {
        if (this.selectedStudent != null &&
            this.selectedStudent.userId != null &&
            !this.studentCardsSelections.some(scs => scs.student.id === this.selectedStudent.id)
        ) {
            let newStudentCardSelection = new StudentCardSelection();
            newStudentCardSelection.student = this.selectedStudent;

            let operators = [];

            if (this.selectedStudent) {
                operators.push(`student.id:${this.selectedStudent.id}`);
            }

            // get the cards that starts before the min date and ends after the max date.
            // because the cards must be broader than the lessons
            if (this.minDate) {
                operators.push(DateUtilities.getDateRangeQuery('validSince',
                    null, this.maxDate));
            }

            if (this.maxDate) {
                operators.push(DateUtilities.getDateRangeQuery('validUntil',
                    this.minDate, null));
            }

            let cardQuery: string =  operators.reduce((query, operator, i) => {
                        query = query + operator + ((i < operators.length - 1) ? ' AND ' : '');
                        return query;
                    }, '');

            this.cardService.search({query: cardQuery})
                    .subscribe(
                    (res: HttpResponse<Card[]>) => {
                        if (!res.body || res.body.length <= 0) {
                            return;
                        }

                        newStudentCardSelection.availableCards = res.body;
                        newStudentCardSelection.selectedCard = res.body[0];
                    }, (res: HttpErrorResponse) => this.onError(res));

            this.studentCardsSelections.push(newStudentCardSelection);
            this.selectedStudent = null;
        }
    }

    calculatePeriod(lessonFamilies: LessonFamilyWithContextDetails[]): { startDate: NgbDateStruct; endDate: NgbDateStruct } | null {
        if (!lessonFamilies || lessonFamilies.length === 0) {
            return null;
        }

        const selectedFamilies: LessonFamily[] = this.getSelectedFamilies();

        const startDate = selectedFamilies.length
            ? selectedFamilies.map(f => new Date(f.startDate))
                              .reduce((min, d) => d < min ? d : min)
            : null; // or undefined or a default date

        const endDate = selectedFamilies.length
            ? selectedFamilies.map(f => new Date(f.endDate))
                              .reduce((max, d) => d > max ? d : max)
            : null; // or undefined or a default date

        return {
            startDate: DateUtilities.toDateStruct(startDate),
            endDate: DateUtilities.toDateStruct(endDate)
        };
    }

    removeSelectedStudent(studentId: number): void {
        const index = this.studentCardsSelections.findIndex(scs => scs.student.id === studentId);
        if (index !== -1) {
            this.studentCardsSelections.splice(index, 1);
        }
    }

    fromDateChanged(fromDate: NgbDateStruct) {
        if (!fromDate) {
            return;
        }

        // We set the min date of the toCalendar to one day after the fromDate
        let minDate: Date = new Date(fromDate.year, fromDate.month - 1, fromDate.day + 1);
        this.minDateUntil = {
            year: minDate.getFullYear(),
            month: minDate.getMonth() + 1,
            day: minDate.getDate()
        };

        // We set the max date of the toCalendar to 12 months from the fromDate
        let maxDate: Date = new Date(fromDate.year, fromDate.month - 1 + 12 , fromDate.day);
        this.maxDateUntil = {
            year: maxDate.getFullYear(),
            month: maxDate.getMonth() + 1,
            day: maxDate.getDate()
        };
        this.currentSearchByDateTo = this.maxDateUntil;
    }

    isSearchLessonFamilyActive() {
        return DateUtilities.isDateRangeValid(this.currentSearchByDateFrom, this.currentSearchByDateTo, false)
                && this.currentSearchByClassType;
    }

    searchLessonFamilies() {
        this.isLoadingLessonFamilies = true;

        let operators = [];

        if (this.currentSearchByDateFrom && this.currentSearchByDateTo) {
            operators.push(DateUtilities.getDateRangeQuery('startDate',
                this.currentSearchByDateFrom, this.currentSearchByDateTo));
        }

        if (this.currentSearchByClassType) {
            operators.push('classType.id:' + this.currentSearchByClassType);
        }

        if (this.currentSearchByLocation) {
            operators.push('location.id:' + this.currentSearchByLocation);
        }

        let lessonFamilyQuery: string =  operators.reduce((query, operator, i) => {
            query = query + operator + ((i < operators.length - 1) ? ' AND ' : '');
            return query;
        }, '');

        // load lesson families based on the filters
        this.lessonFamilyService
            .search({ query: lessonFamilyQuery })
            .pipe(
                map((res: HttpResponse<LessonFamily[]>) => res.body || []),
                map(list => (list || []).map(LessonFamilyWithContextDetails.fromLessonFamily)),
                switchMap((families: LessonFamilyWithContextDetails[]) => {
                    if (!families.length) {
                        return of(families);
                    }

                    const countCalls = families.map(f => {
                        let notCancelledLessonsQuery: String = 
                                         'lessonFamilyId:' + f.id + ' AND status:(OPEN OR EXECUTED)';
                        
                        return this.lessonService
                        .count({ query: notCancelledLessonsQuery  })
                        .pipe(
                            catchError((_e: HttpErrorResponse) => of(0)),
                            map((count: number) => {
                                f.lessonsCount = count; // keep same instance for bindings
                                return f;
                            })
                        )
                    });
                    return forkJoin(countCalls);
                }),
                catchError((err: HttpErrorResponse) => {
                    this.onError(err);
                    return of([]);
                }),
                finalize(() => (this.isLoadingLessonFamilies = false)) // ensures the flag flips on success or error
            )
            .subscribe((families: LessonFamilyWithContextDetails[]) => {
               let familyList: LessonFamilyWithContextDetails[] = families || [];
               this.lessonFamilies = familyList.filter (family => family.lessonsCount > 0);
            });

    }

    getSelectedFamilies(): LessonFamily[] {
        return !this.lessonFamilies ? [] : this.lessonFamilies.filter(f => f.selected);
    }

    planReservations() {
        this.isLoadingRecurrintReservations = true;
        this.recurrentReservationCurrentStep = 3;

        const cardIds: number [] = [];
        const lessonFamilyIds: number [] = [];
        this.studentCardsSelections
            .filter(scs => scs.selectedCard)
            .forEach(scs => {
                cardIds.push(scs.selectedCard.id);
            });

        this.getSelectedFamilies().forEach(lf => {
            lessonFamilyIds.push(lf.id);
        });

        if (!this.currentAttemptKey) {
             this.currentAttemptKey = this.newAttemptKey();
        }

        const bulkCreateInput: ReservationFamilyBulkCreateInput = new ReservationFamilyBulkCreateInput(
            this.currentAttemptKey, cardIds, lessonFamilyIds );

        this.reservationFamilyService.bulkCreate(bulkCreateInput)
            .subscribe(
                (res: any) => {
                    this.waitForBackGroundJob();
                }, (error: HttpErrorResponse) => {
                    this.onError(error);
                });
    }

    private waitForBackGroundJob() {
        this.pollSubscription = timer(0, this.pollIntervalMs)
                                .pipe(
                                    takeUntil(this.destroy$),
                                    switchMap(() => this.reservationFamilyService
                                                        .getBulkCreateResult(this.currentAttemptKey)
                                                        .pipe(
                                                            catchError(
                                                                (err): Observable<ReservationFamilyBulkCreateBackgroundJobResult> => {
                                                                    this.lastError = err && err.message ? err.message : 'Network error';
                                                                    let fallBack: ReservationFamilyBulkCreateBackgroundJobResult;
                                                                    fallBack = new ReservationFamilyBulkCreateBackgroundJobResult(
                                                                        this.currentAttemptKey, 'Unknown'
                                                                    );
                                                                    return observableOf(fallBack);
                                                            })
                                                        )
                                    ),
                                    tap((resp: ReservationFamilyBulkCreateBackgroundJobResult) => {
                                        this.reservationFamilyBulkCreateResult = resp;
                                    }),
                                    // keep polling while PENDING; emit the final SUCCEEDED once, then complete
                                    takeWhile((resp: ReservationFamilyBulkCreateBackgroundJobResult) => {
                                        return resp.status === 'PENDING';
                                    })
                                ).subscribe({
                                complete: () => {
                                    const delayBeforeHandling = 1000;
                                    setTimeout(() => this.handleBackgroundJobCompletion(), delayBeforeHandling);
                                }
                            });

    }

    private showResultOfBackgroundJob() {
    }

    private handleBackgroundJobCompletion() {
        if (!this.reservationFamilyBulkCreateResult) {
            return;
        };

        if (this.reservationFamilyBulkCreateResult.status === 'SUCCEEDED' ) {
            // job finished -> clear the key for the next attempt
            this.currentAttemptKey = null;
            // handle success
            this.eventManager.broadcast({ name: 'reservationFamilyListModification'
                , content: {}
            });
            this.goToStep(4);
        } else if (this.reservationFamilyBulkCreateResult.status === 'FAILED' ) {
            // job finished -> clear the key for the next attempt
            this.currentAttemptKey = null;
            // handle error
        }
    }


    private loadClassTypesList() {
        this.classTypeService.search({query: 'active:true'})
        .subscribe(
            (res: HttpResponse<ClassType[]>) => {
                if (!res.body) {
                    return;
                }

                this.classTypes = this.classTypeUtilService.orderClassTypesByName(res.body);
            },
            (res: HttpErrorResponse) => {
                this.onError(res);
            }
        );
    }

    private loadLocationList() {
        this.locationService.search({query: 'active:true'})
        .subscribe(
            (res: HttpResponse<Location[]>) => {
                this.locations = res.body;
            },
            (res: HttpErrorResponse) => {
                this.onError(res);
            }
        );
    }

    goToStep(stepNumber: number) {
        this.recurrentReservationCurrentStep = stepNumber;

        switch (stepNumber) {
            case 1:
                this.studentCardsSelections = [];
                this.loadClassTypesList();
                this.loadLocationList();
                break;
            case 2:
                let period = this.calculatePeriod(this.lessonFamilies);
                this.minDate = period.startDate;
                this.maxDate = period.endDate;
                break;
            case 3:
                this.planReservations();
                break;
            case 4:
                this.showResultOfBackgroundJob();
                break;
        }
    }

    enableGoToStepButton(stepNumber: number): boolean {
        switch (stepNumber) {
            case 1:
                return true;
            case 2:
                const selectedFamilies = this.getSelectedFamilies();
                return selectedFamilies.length > 0;
            case 3:
                if (!this.studentCardsSelections) {
                    return false;
                }
                return this.studentCardsSelections.length > 0;
        }
    }

    initWorkflow() {
        this.isLoadingLessonFamilies = false;
        this.isLoadingRecurrintReservations = false;
        this.currentSearchByClassType = null;
        this.currentSearchByLocation = null;
        this.currentSearchByDateFrom = null;
        this.currentSearchByDateTo = null;
        this.lessonFamilies = null;
        this.studentCardsSelections = null;
        this.classTypes = null;
        this.locations = null;
        this.goToStep(1);
    }

    getLabelForSmallDevices(value: string): string {
        return LessonUtilService.getLabelForSmallDevices(value);
    }

    getLessonFamilyStyle(lessonFamily: LessonFamily) {
        let color =  LessonUtilService.getBackgroundColorForClassType(lessonFamily.classType);
        return  {'color': color};
    }

    previousState() {
        window.history.back();
    }

    registerChangeInCards() {
        this.cardSubscriber = this.eventManager.subscribe('cardListModification',
            (response) =>
                this.handleCardCreation(response.content)
        );
    }

    private handleCardCreation(result: { action: string, content: any }) {
        let card: Card = result.content;
        let action: String = result.action;

        switch (action) {
            case CRUD_ACTIONS.CREATE:
                // add the card to the list of cards of the given student and select it by default
                let studentCardSelection: StudentCardSelection = this.studentCardsSelections
                                                                     .find(scs => scs.student.id === card.student.id );

                if (studentCardSelection) {
                    let availableCards: Card[] = studentCardSelection.availableCards;

                    if (!availableCards) {
                        studentCardSelection.availableCards = [];
                    }

                    studentCardSelection.availableCards.push(card);
                    studentCardSelection.selectedCard = card;
                }

                break;
        }
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
        if (this.pollSubscription) {
            this.pollSubscription.unsubscribe();
        }
        this.cardSubscriber.unsubscribe();
    }

    // TODO replace this bitwise operators with uuidv4()
    private newAttemptKey(): string {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation-family/reservation-family-create.component.ts